import { useState } from 'react';
import { advanceSoon, ContinueButton, BackButton, RequiredNote } from './common.jsx';

// Single-select option list. Auto-advances unless the chosen option has follow-up
// fields (employment -> occupation/hours), in which case they render and the user
// confirms with Continue. Follow-up answers keep their own field ids.
export default function SingleSelect({ item, answers, setAnswer, onAdvance }) {
  const val = answers[item.id];
  const followups = (item.followups && val && item.followups[val]) || null;
  // Employment reveals occupation/hours; those flagged required must be filled to advance.
  const followupIncomplete = followups
    && followups.some((f) => f.required_when_shown && !(answers[f.id] || '').trim());
  // See YesNo: hide Continue during the auto-advance window to avoid a flash.
  const [advancing, setAdvancing] = useState(false);

  const choose = (v) => {
    setAnswer(item.id, v);
    if (item.followups && item.followups[v]) return; // reveal fields, wait
    setAdvancing(true);
    advanceSoon(onAdvance);
  };

  return (
    <>
      <h1>{item.label}</h1>
      <div className="optbox">
        {item.options.map((v) => (
          <button key={v} className={`selbtn${val === v ? ' sel' : ''}`} onClick={() => choose(v)}>
            {val === v ? '✓ ' : ''}{v}
          </button>
        ))}
      </div>
      {followups ? (
        <div>
          {followups.map((f) => (
            <div key={f.id}>
              <label className="flab">{f.label}</label>
              <input
                className="win"
                style={{ marginBottom: 12 }}
                type={f.type === 'num' ? 'text' : 'text'}
                inputMode={f.type === 'num' ? 'numeric' : undefined}
                value={answers[f.id] || ''}
                onChange={(e) => setAnswer(f.id, e.target.value)}
              />
            </div>
          ))}
          {followupIncomplete && <RequiredNote />}
          <div className="spacer" style={{ height: 6 }} />
          <ContinueButton onClick={onAdvance} disabled={followupIncomplete} />
        </div>
      ) : val !== undefined && !advancing ? (
        // Already answered (e.g. resumed) — explicit Continue so it's clear how to proceed.
        <ContinueButton onClick={onAdvance} />
      ) : (
        <BackButton />
      )}
    </>
  );
}
